<script setup lang="ts">
  import CalculatorSearchCar from '@/components/calculator/CalculatorSearchCar.vue';
  import { onMounted, ref } from 'vue';
  import { additionalCosts, carData } from '@/types';
  import { getSession } from '@/indexedDB';
  const dataCar = ref<carData | null>(null);
  const additionalFields = ref<additionalCosts>({
    expeditionCost: 320,
    certification: 160,
    parkingCost: 50,
    customsCost: 0,
    towingCost: 850,
    serviceCost: 0,
    pensionCost: 0,
  });

  onMounted(async () => {
    dataCar.value = await getSession('car');
    additionalFields.value = await getSession('additionalFields');
  });
</script>

<template>
  <CalculatorSearchCar
    :car-data="dataCar"
    :additionalFields="additionalFields"
  />
</template>

<style scoped></style>
